import React, { useEffect, useState } from 'react';

import { Box, Checkbox, Container, FormLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/styles';
import { ICountryNameInStopsWithTotal } from '../../types';
import Typography from '@mui/material/Typography';

interface Props {
	data: ICountryNameInStopsWithTotal[];
	handleChangeFilter: (data: string[] | null) => void;
}

const useStyles = makeStyles(() => ({
	title: {
		fontSize: '15px',
		fontWeight: 'bold',
		color: 'white',
	},
	filterContent: {
		backgroundColor: 'rgb(241, 242, 241)',
		borderBottomRightRadius: '14px',
		borderBottomLeftRadius: '14px',
		padding: '0px',
		transition: 'max-height 0.26s ease 0s, padding 0.26s ease 0s',
		paddingLeft: '15px',
	},
	totalInfo: {
		justifyContent: 'center',
		alignItems: 'center',
		width: 'auto',
		display: 'inline-flex',
		fontSize: '14px',
		fontWeight: '500',
		height: '15px',
		marginTop: '5px',
		textAlign: 'center',
		borderRadius: '14px',
		padding: '4px 8px',
		boxShadow: 'rgba(0, 0, 0, 0.25) 1px 1px 3px 0px',
		backgroundColor: 'rgb(255, 103, 0)',
		color: 'rgb(255, 255, 255)',
	},
}));

export const FlightExplorerCountryExcludeInStopFilter = ({ data, handleChangeFilter }: Props): JSX.Element => {
	const classes = useStyles();
	const [countryNamesSelected, setCountryNameSelected] = useState<string[]>([]);
	const theme = useTheme();

	const handleChangeCountryNameCheckBox = (event: React.ChangeEvent<HTMLInputElement>, countryName: string) => {
		if (event.target.checked) {
			setCountryNameSelected([...countryNamesSelected, countryName]);
		} else {
			setCountryNameSelected([
				...countryNamesSelected.filter((countryNameSelected) => countryNameSelected !== countryName),
			]);
		}
	};

	useEffect(() => {
		setTimeout(() => handleChangeFilter(countryNamesSelected.length > 0 ? countryNamesSelected : null), 10);
	}, [countryNamesSelected]);

	return (
		<Container sx={{ 'margin-bottom': '15px' }}>
			<Box sx={{ 'padding-left': '15px', backgroundColor: '#8167A3', height: '25px' }}>
				<FormLabel className={classes.title}>Países a excluir en las escalas</FormLabel>
			</Box>
			<Box className={classes.filterContent}>
				{data.map((countryNameWithTotal, index) => (
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							paddingTop: '5px',
							paddingRight: '10px',
							paddingBottom: '5px',
						}}
						key={'airline-filter-' + index}
					>
						<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'left' }}>
							<Checkbox
								checked={countryNamesSelected.some((x) => x == countryNameWithTotal.countryName)}
								onChange={(event) => handleChangeCountryNameCheckBox(event, countryNameWithTotal.countryName)}
								color="secondary"
								sx={{ paddingRight: '10px', paddingBottom: 0, paddingTop: 0, paddingLeft: 0 }}
							/>
							<Typography
								variant="subtitle1"
								component="span"
								style={{ color: theme.palette.primary.main, fontSize: '13px' }}
							>
								{' '}
								{countryNameWithTotal.countryName}
							</Typography>
						</div>

						<Typography variant="subtitle1" component="span" className={`${classes.totalInfo}`}>
							{' '}
							{countryNameWithTotal.total}
						</Typography>
					</div>
				))}
			</Box>
		</Container>
	);
};
